import { Area } from '../../types/common.types';

export type RouteOption =
	| 'tasks'
	| 'openCases'
	| 'processes'
	| 'otherRequests'
	| 'systemDashboard'
	| 'createUser'
	| 'updateUser'
	| 'deleteUser'
	| 'auditTrail'
	| 'extraccion'
	| 'companyInfo'
	| 'superAdminDashboard'
	| 'createSystemUser';

export const pathToOption: Record<string, RouteOption> = {
	'/dashboard': 'tasks',
	'/casos': 'openCases',
	'/procesos': 'processes',
	'/other-requests': 'otherRequests',
	'/system-dashboard': 'systemDashboard',
	'/create-user': 'createUser',
	'/update-user': 'updateUser',
	'/delete-user': 'deleteUser',
	'/audit-trail': 'auditTrail',
	'/extraccion': 'extraccion',
	'/company-info': 'companyInfo',
	'/superadmin/dashboard': 'superAdminDashboard',
	'/superadmin/create-system-user': 'createSystemUser',
};

export const optionToPath: Record<RouteOption, string> = {
	tasks: '/dashboard',
	openCases: '/casos',
	processes: '/procesos',
	otherRequests: '/other-requests',
	systemDashboard: '/system-dashboard',
	createUser: '/create-user',
	updateUser: '/update-user',
	deleteUser: '/delete-user',
	auditTrail: '/audit-trail',
	extraccion: '/extraccion',
	companyInfo: '/company-info',
	superAdminDashboard: '/superadmin/dashboard',
	createSystemUser: '/superadmin/create-system-user',
};

export const areaOptions: Record<Area | 'SuperAdmin', RouteOption[]> = {
	SuperAdmin: ['superAdminDashboard', 'createSystemUser'],
	System: [
		'systemDashboard',
		'companyInfo',
		'createUser',
		'updateUser',
		'deleteUser',
		'auditTrail',
	],
	ESG: ['openCases'],
	MedioAmbiental: ['openCases'],
	EstandaresSociales: ['openCases'],
	GobiernoCorporativo: ['openCases'],
	Financiero: ['openCases'],
	Extraccion: ['extraccion'],
};

// La URL se lee del archivo .env (REACT_APP_BACKEND_URL)
// Para cambiar entre desarrollo y producción, edita el archivo .env
export const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://risincome.aicrumit.com/backend';
export const ROUTE_METRICS = `${BASE_URL}/metrics`;
export const ROUTE_API = `${BASE_URL}/api`;
export const ROUTE_COMPANY_COMPLETE = `${ROUTE_API}/casos/completar`;
export const ROUTE_COMPANY_LIST = `${ROUTE_API}/casos/list`;
export const ROUTE_COMPANY_CREATE_WITH_FORMS = `${ROUTE_API}/casos/create-with-forms`;
export const ROUTE_COMPANY_FINISHED_COMPANIES = `${ROUTE_API}/casos/casos-acabadas`;
export const ROUTE_COMPANY_CHECK_ESRS2 = `${ROUTE_API}/casos/check-esrs2`;
export const ROUTE_COMPANY_EXPORT_DETAILS = `${ROUTE_API}/casos/exportar-detalles`;
export const ROUTE_CASO_FORMULARIOS = (casoId: string | number): string => `${ROUTE_API}/casos/${casoId}/formularios`;
export const ROUTE_COMPANY_INFO = `${ROUTE_API}/company`;
export const ROUTE_COMPANY_INFO_BY_ID = (id: string | number): string => `${ROUTE_API}/company/${id}`;
export const ROUTE_AUTH_LOGIN = `${ROUTE_API}/auth/login`;
export const ROUTE_AUTH_LOGOUT = `${ROUTE_API}/auth/logout`;
export const ROUTE_AUTH_REFRESH = `${ROUTE_API}/auth/refresh`;
export const ROUTE_AUTH_ME = `${ROUTE_API}/auth/me`;
export const ROUTE_FORMS = `${ROUTE_API}/formularios`;
export const ROUTE_RESPONSES = `${ROUTE_API}/respuestas`;
export const ROUTE_RESPONSES_COMPANY = `${ROUTE_RESPONSES}/empresa`;
export const ROUTE_RESPONSES_REDIRECTED = `${ROUTE_RESPONSES}/redirigidas`;
export const ROUTE_USERS = `${ROUTE_API}/users`;
export const ROUTE_USERS_BY_AREA_DEPARTMENT = `${ROUTE_USERS}/by-area-department`;
export const ROUTE_NOTIFICATIONS = `${ROUTE_API}/notificaciones`;
export const ROUTE_NOTIFICATIONS_REQUIREMENT_ACTIVATED = `${ROUTE_NOTIFICATIONS}/requisito-activado`;
export const ROUTE_NOTIFICATIONS_REDIRECTION = `${ROUTE_NOTIFICATIONS}/redireccion`;
export const ROUTE_EXPORT = `${ROUTE_API}/exportar`;
export const ROUTE_EXPORT_PDF = `${ROUTE_EXPORT}/pdf`;
export const ROUTE_EXPORT_WORD = `${ROUTE_EXPORT}/word`;
export const ROUTE_EXPORT_ANNUAL_PDF = `${ROUTE_EXPORT}/annual/pdf`;
export const ROUTE_EXPORT_ANNUAL_WORD = `${ROUTE_EXPORT}/annual/word`;
export const ROUTE_EXPORT_ANNUAL_XBRL = `${ROUTE_EXPORT}/annual/xbrl`;
export const ROUTE_RESTRICTED_EXPORT = `${ROUTE_API}/restricted-export`;
export const ROUTE_PROCESSES = `${ROUTE_API}/procesos`;
export const ROUTE_AUTH_CHANGE_FIRST_PASSWORD = `${ROUTE_API}/auth/change-first-password`;
export const ROUTE_AUTH_RESET_PASSWORD = `${ROUTE_API}/auth/reset-password`;
export const ROUTE_NOTIFICATIONS_RECOVER_PASSWORD = `${ROUTE_NOTIFICATIONS}/recuperar-password`;
export const ROUTE_COPY_RESPONSES = `${ROUTE_API}/copy-responses/copy-from-previous-year`;
export const ROUTE_AVAILABLE_YEARS = `${ROUTE_API}/copy-responses/available-years`;
export const ROUTE_AUDIT = `${ROUTE_API}/audit`;
export const ROUTE_AUDIT_TRAIL = `${ROUTE_AUDIT}/trail`;
export const ROUTE_AUDIT_USERS = `${ROUTE_AUDIT}/users`;
export const ROUTE_AUDIT_COMPANIES = `${ROUTE_AUDIT}/companies`;
export const ROUTE_AUDIT_PROCESSES = `${ROUTE_AUDIT}/processes`;
export const ROUTE_AUDIT_FORMS = `${ROUTE_AUDIT}/forms`;
export const ROUTE_AUDIT_STATS = `${ROUTE_AUDIT}/stats`;
export const ROUTE_AUDIT_YEARS = `${ROUTE_AUDIT}/years`;
export const ROUTE_ENVIRONMENTAL = `${ROUTE_API}/environmental`;
export const ROUTE_ENVIRONMENTAL_METRICS_REQUESTS = `${ROUTE_ENVIRONMENTAL}/metrics-requests`;
export const ROUTE_ENVIRONMENTAL_COMPANY_REPORT = `${ROUTE_ENVIRONMENTAL}/company-report`;
export const ROUTE_ENVIRONMENTAL_METRICS_BY_ID = (id: string | number): string =>
	`${ROUTE_ENVIRONMENTAL}/metrics-requests/${id}`;
